import type { FunctionComponent } from 'react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { FFFErrorBoundary } from '@fff-web/fff-ui-shared';
import AnalyticsWrapper from './AnalyticsWrapper';
import { addPathPrefix } from './helpers';
import ContactUs from './pages/ContactUs';
import EmailPreferences from './pages/EmailPreferences';
import { LockInRatePage } from './pages/LockInRate';
import MyAccountContainer from './pages/MyAccount';
import NotFoundError from './pages/NotFoundError';
import ReactivateThanks from './pages/ReactivateThanks';
import ReactivateToday from './pages/ReactivateToday';
import ShipmentTracking from './pages/ShipmentTracking';
import SubscribeToday from './pages/SubscribeToday';
import TrialUpgrade from './pages/TrialUpgrade';
import TrialUpgradeThanks from './pages/TrialUpgradeThanks';
import { UpgradeRoot } from './pages/UpgradeRedesign';
import UpgradeThanks from './pages/UpgradeThanks';
import {
  ACTIVATE_BOX_SUBSCRIPTION,
  ACTIVATE_MEMBERSHIP,
  CONTACT_US_PATH,
  EMAIL_PREFERENCES,
  LOCK_IN_RATE_PATH,
  MY_ACCOUNT,
  ORDER_TRACKING,
  REACTIVATE_THANKS,
  REACTIVATE_TODAY,
  SUBSCRIBE_TODAY_THANKS,
  TRIAL_UPGRADE_THANKS,
  UPGRADE_CONFIRMATION,
  UPGRADE_THANKS,
} from './utils/routePaths';

type Props = {
  flags: {
    newMyAccount: string;
    newUpgrade: boolean;
    newReactivate: boolean;
  };
};

export const AppRoutes: FunctionComponent<Props> = ({ flags }) => {
  if (!flags || Object.keys(flags).length === 0) {
    return null;
  }

  return (
    <FFFErrorBoundary>
      <Router>
        <AnalyticsWrapper>
          <Routes>
            {flags.newReactivate !== false && (
              <Route path={addPathPrefix(REACTIVATE_TODAY)} element={<ReactivateToday />} />
            )}
            {flags.newReactivate !== false && (
              <Route path={addPathPrefix(REACTIVATE_THANKS)} element={<ReactivateThanks />} />
            )}
            {flags.newUpgrade !== false && (
              <Route path={addPathPrefix(UPGRADE_CONFIRMATION)} element={<UpgradeRoot />} />
            )}
            {flags.newUpgrade !== false && (
              <Route path={addPathPrefix(ACTIVATE_MEMBERSHIP)} element={<TrialUpgrade />} />
            )}
            {flags.newUpgrade !== false && (
              <Route path={addPathPrefix(UPGRADE_THANKS)} element={<UpgradeThanks />} />
            )}
            <Route path={ACTIVATE_BOX_SUBSCRIPTION} element={<SubscribeToday />} />
            <Route path={addPathPrefix(TRIAL_UPGRADE_THANKS)} element={<TrialUpgradeThanks />} />
            <Route path={addPathPrefix(EMAIL_PREFERENCES)} element={<EmailPreferences />} />
            <Route path={SUBSCRIBE_TODAY_THANKS} element={<ReactivateThanks />} />
            <Route
              path={addPathPrefix(`${MY_ACCOUNT}${ORDER_TRACKING}/:orderShipmentId?`)}
              element={<ShipmentTracking />}
            />
            <Route path={addPathPrefix(`${MY_ACCOUNT}/*`)} element={<MyAccountContainer />} />
            <Route path={LOCK_IN_RATE_PATH} element={<LockInRatePage />} />
            <Route path={CONTACT_US_PATH} element={<ContactUs />} />
            <Route path="*" element={<NotFoundError />} />
          </Routes>
        </AnalyticsWrapper>
      </Router>
    </FFFErrorBoundary>
  );
};

export default withLDConsumer()(AppRoutes);
